import React from 'react'

import { Box, Divider, Text } from '@factorialco/deprecated-design-system'
import { F0Button, F0ButtonProps, F0TagRaw, IconType } from '@factorialco/f0-react'
import { Dropdown, DropdownItem, Spinner } from '@factorialco/f0-react/dist/experimental'
import { Ellipsis } from '@factorialco/f0-react/icons/app'

export type EditorHeaderMetadataItem =
  | { type: 'raw-tag'; text: string; icon?: IconType }
  | { type: 'text'; label: string }
  | { type: 'spinner'; label: string }
  | { type: 'divider' }

export type ActionType = {
  label: string
  onClick: () => void
  disabled?: boolean
  icon?: IconType
  hideLabel?: boolean
  variant?: F0ButtonProps['variant']
}
interface EditorHeaderProps {
  metadata: EditorHeaderMetadataItem[]
  dropdownActions?: DropdownItem[]
  actions?: ActionType[]
}

const renderMetadataItem = (item: EditorHeaderMetadataItem, index: number) => {
  switch (item.type) {
    case 'raw-tag':
      return <F0TagRaw key={index} text={item.text} icon={item.icon} />
    case 'text':
      return (
        <Text key={index} size="300">
          {item.label}
        </Text>
      )
    case 'spinner':
      return (
        <Box key={index} flexDirection="row" alignItems="center" gap="s8">
          <Spinner size="medium" />
          <Text.Normal>{item.label}</Text.Normal>
        </Box>
      )
    case 'divider':
      return <Divider key={index} component="div" vertical />
    default:
      return <></>
  }
}

export const EditorHeader: React.FC<EditorHeaderProps> = ({
  metadata,
  dropdownActions,
  actions,
}) => {
  return (
    <Box alignItems="flexStart" flexDirection="row" gap="s12" justifyContent="spaceBetween">
      <Box alignItems="flexStart" flexDirection="row" gap="s12">
        {metadata.map((item, index) => renderMetadataItem(item, index))}
      </Box>
      <Box alignItems="flexStart" flexDirection="row" gap="s12">
        {dropdownActions && dropdownActions.length > 0 && (
          <Dropdown items={dropdownActions} icon={Ellipsis} />
        )}
        {actions?.map((action, index) => (
          <F0Button
            key={index}
            onClick={action.onClick}
            disabled={action.disabled}
            icon={action.icon}
            hideLabel={action.hideLabel}
            variant={action.variant}
            label={action.label}
          />
        ))}
      </Box>
    </Box>
  )
}
